var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.8013 0.874947H35.3971L28.8861 12.0952L20.9666 0.64917H7.08049H0.00538987V19.2659H7.08049V7.76207H17.2709L24.9569 18.8703L20.5498 26.4637L18.9418 29.2362H0V36.3491H14.8149H23.0417L31.7086 21.4135L39.4987 7.98784H47.9231V36.3509H55V0.874947H35.8013Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.fb2ab378ce6109d0d1ac1f809669dad1.svg";
export { ForwardRef as ReactComponent };